
import {getAmountReferrals} from '../api/getAmountReferrals';
import {setGetAmountReferralsAction} from '../action';

const setGetAmountReferrals = (params) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getAmountReferrals(params);

            if (data.status === 'success') {
                dispatch(setGetAmountReferralsAction(data.data));           
            }
          
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setGetAmountReferrals
}